var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.725C6.02025 9.1814 6.081 8.63015 6.18225 8.07125C6.2565 7.65545 6.2943 7.44755 6.42255 7.30512C6.5508 7.1627 6.86805 7.06213 7.50187 6.85963C9.06112 6.36283 10.3787 5 12.4111 5C14.4436 5 15.7639 6.3635 17.3231 6.85963C17.9569 7.06213 18.2735 7.1627 18.4018 7.30512C18.53 7.44687 18.5678 7.65545 18.6427 8.07125C18.744 8.63015 18.8047 9.1814 18.825 9.725M17.4379 15.125C16.5469 16.4905 15.232 17.58 13.5026 18.2422C13.0524 18.4143 12.8276 18.5 12.4132 18.5C12.0001 18.5 11.7746 18.4136 11.3244 18.2415C9.59505 17.58 8.28015 16.4905 7.38847 15.125M10.05 11.75L10.725 12.425M10.725 12.425L11.4 13.1M10.725 12.425L11.4 11.75M10.725 12.425L10.05 13.1M6.675 11.75L7.35 12.425M7.35 12.425L8.025 13.1M7.35 12.425L8.025 11.75M7.35 12.425L6.675 13.1M13.425 11.75L14.1 12.425M14.1 12.425L14.775 13.1M14.1 12.425L14.775 11.75M14.1 12.425L13.425 13.1M16.8 11.75L17.475 12.425M17.475 12.425L18.15 13.1M17.475 12.425L18.15 11.75M17.475 12.425L16.8 13.1",
    stroke: "#475569",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/SecurityIcon.79ea593929f294eb1fe9308e652f1dc9.svg";
export { ForwardRef as ReactComponent };